import axios from '../utils/axios';

export default function updateDomainInfo(adminId, data) {
    return axios.post('/admin/' + adminId + '/domain-info-update', data)
        .then(res => {
            return res.data;
        }).catch(err => {
            return err;
        })
}